import { useTranslation } from "react-i18next";
import { Link } from "@components/Link/Link";

interface ICompanyPhoneLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: "local" | "short";
}

export const CompanyPhoneLink: React.FC<ICompanyPhoneLinkProps> = ({
  variant = "local",
}) => {
  const { t } = useTranslation();
  const companyPhoneNumber =
    variant === "local"
      ? t("common.company.localPhone")
      : t("common.company.shortPhone");

  return (
    <Link className="text-blue-dark" to={`tel:${companyPhoneNumber}`}>
      {companyPhoneNumber}
    </Link>
  );
};
